import React from 'react';
import { Dropdown } from '~/native-ui/Dropdown';

export class YesNoSelect extends React.Component {
    static propTypes = {};

    getSource = () => {
        let { trans } = this.props;

        return [
            { value: true, label: trans('yes') },
            { value: false, label: trans('no') },
        ].filter((v) => v);
    };

    handleSelect = (value) => {
        this.props.onChange(value);
    };

    render() {
        return (
            <Dropdown
                label={this.props.title}
                tooltip={this.props.tooltip}
                value={this.props.value === null ? null : this.props.value}
                source={this.getSource()}
                onChange={this.handleSelect}
            />
        );
    }
}
